import { css, Interpolation, Theme } from '@emotion/react'

export const clickAway: (isOpen?: boolean) => Interpolation<Theme> = (isOpen) =>
  css`
    display: ${isOpen ? 'block' : 'none'};
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    backdrop-filter: blur(7.5px);
    z-index: 1500;
  `

export const content: (isOpen?: boolean) => Interpolation<Theme> = (isOpen) =>
  css`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${isOpen ? 250 : 0}px;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    z-index: 1600;
  `

export const toggleButton: (isOpen?: boolean) => Interpolation<Theme> = (isOpen) => (theme) =>
  css`
    position: absolute;
    top: 4px;
    left: 4px;
    height: 32px;
    width: 32px;
    padding: 6px;
    margin-left: ${isOpen ? 250 : 0}px;
    transition: all 0.3s ease-in-out;
    background: ${theme.colors.black};
    z-index: 1600;

    &:hover {
      background: ${theme.colors.black};
    }

    svg {
      transform: rotate(${isOpen ? 180 : 0}deg);
      transition: all 0.3s ease-in-out;

      path {
        stroke: ${theme.colors.white};
      }
    }
  `

export const wrapper: Interpolation<Theme> = (theme) => css`
  height: 100%;
  width: 250px;
  background: ${theme.backgrounds.backgroundFour};
  border-right: 1px solid ${theme.backgrounds.backgroundOne};
  padding: 23px 15px 23px 16px;
  overflow-y: scroll;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    display: none;
  }
`

export const skeleton: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 24px;

  div {
    display: flex;
    flex-direction: column;
    gap: 10px;

    div {
      display: flex;
      flex-direction: column;
      gap: 8px;

      div {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px;
        gap: 10px;
      }
    }
  }
`

export const copyright: Interpolation<Theme> = (theme) => css`
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: ${theme.typographyColors.typographyFour};
`
